export enum CardRarity {
	common = "common",
	uncommon = "uncommon",
	rare = "rare",
	mythic = "mythic",
	special = "special",
}

export const readableRarity = {
	[CardRarity.common]: "Common",
	[CardRarity.uncommon]: "Uncommon",
	[CardRarity.rare]: "Rare",
	[CardRarity.mythic]: "Mythic",
	[CardRarity.special]: "Special",
};

export const rarityOrder = {
	[CardRarity.common]: 0,
	[CardRarity.uncommon]: 1,
	[CardRarity.rare]: 2,
	[CardRarity.mythic]: 3,
	[CardRarity.special]: 4,
};

export const raritySort = (a: string, b: string) => {
	return (
		(rarityOrder[a.toLowerCase() as keyof typeof rarityOrder] ??
			Number.POSITIVE_INFINITY) -
		(rarityOrder[b.toLowerCase() as keyof typeof rarityOrder] ??
			Number.POSITIVE_INFINITY)
	);
};
